import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { requestValidatePayment } from "../../../api";
// import { bin2hex } from "../../utils/razorpay-encrypt.js";
import Cookie from "universal-cookie";
const universalCookie = new Cookie();

class PayByRazorPay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paid: false,
      popupLogin: false,
      login: !!universalCookie.get("vuid")
    };
    this.intervalLogin = "";
    this.orderData = get(props, ["orderData"]);
    this.storyUrl = get(props, ["storyUrl"]);
    this.closeModal = get(props, ["closeModal"]);
    this.amount = get(props, ["amount"]);
    this.vuid = get(props, ["vuid"], "");
    this.type = get(props, ["orderType"]);
    this.ShowSuccess = get(props, ["ShowSuccess"]);
    this.showLoader = get(props, ["showLoader"]);
    this.razaorpayKey = get(props, ["razaorpayKey", "key"]);
    this.userInfo = get(props, ["userInfo"]);
    this.countryCode = get(props, ["countryCode"]);

    let ValidCode = new RegExp(/[^\d\s]/).test(this.userInfo);
    let EmailValid = "";
    let PhoneValid = "";

    if (ValidCode === true) {
      EmailValid = this.userInfo;
    } else {
      PhoneValid = `${this.countryCode}${this.userInfo}`;
    }

    this.options = {
      key: this.razaorpayKey,
      amount: this.amount * 100, //  = INR 1
      currency: "INR",
      name: "Vikatan",
      description: "Vikatan Payment",
      image: "https://gumlet.vikatan.com/vikatan/2019-12/35fa820d-80d7-440d-83ff-7fbecfd632aa/vikatanthatha.png?w=50",
      handler: function(response) {
        this.showLoader();
        requestValidatePayment(
          Object.assign(response, {
            order_id: this.orderData && this.orderData.order_id,
            vuid: this.vuid,
            mode: "live",
            order_type: this.type
          })
        ).then(
          function(res) {
            if (res.status === 1) {
              if (!this.state.login) {
                universalCookie.set("vuid", res.vuid, {
                  domain: ".vikatan.com",
                  path: "/"
                });
              }
              this.ShowSuccess();
            }
          }.bind(this)
        );
      }.bind(this),
      prefill: {
        name: "",
        contact: this.orderData && this.orderData.mobile_number ? this.orderData.mobile_number : PhoneValid,
        email: this.orderData && this.orderData.email_id ? this.orderData.email_id : EmailValid
      },
      notes: {
        order_id: this.orderData && this.orderData.order_id,
        user_id: this.orderData && this.orderData.user_id
      },
      theme: {
        color: "#2bab64"
      },
      config: {
        display: {
          hide: [
            {
              method: "upi",
              flows: ["main_qr"]
            }
          ]
        }
      }
    };
    this.customStyles = {
      content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        zIndex: 99999
      }
    };

    if (this.type === "Online_Subscription" || this.type === "Single_Issue_Product") {
      Object.assign(this.options, { order_id: this.orderData && this.orderData.razorpay_order_id });
    }

    if (this.type === "recurring_subscription") {
      Object.assign(this.options, { subscription_id: this.orderData && this.orderData.razor_sub_id });
      Object.assign(this.options.notes, {
        vik_sub_id: this.orderData && this.orderData.vik_sub_id,
        next_due: this.orderData && this.orderData.next_due
      });
    }
  }

  openPayModal = () => {
    var rzp1 = new window.Razorpay(this.options);
    rzp1.open();
    this.closeModal();
  };

  componentDidMount() {
    if (this.orderData) {
      this.openPayModal();
    }
  }
  render() {
    return (
      <React.Fragment>
        <div />
      </React.Fragment>
    );
  }
}

PayByRazorPay.propTypes = {
  vuid: PropTypes.string,
  closeModal: PropTypes.func,
  showLoader: PropTypes.func,
  ShowSuccess: PropTypes.func
};

export default PayByRazorPay;
